module.exports = __webpack_public_path__ + "img/man.45266c2c.jpg";